// Controller manifest. Each entry is loaded on demand, the first time an element
// with the matching data-controller enters the DOM (initial parse, Turbo visit
// or Turbo Stream). Add new controllers here, keep the list alphabetical.

import { application } from "./application";
import AnimationController from "./animation_controller.js";
import { lazyLoadControllers } from "./lazy-loading";

// Not lazy, needed so loading screen animation starts from the get go
application.register("animation", AnimationController);

lazyLoadControllers(application, {
  "accordeon-group": () => import("./accordeon-group_controller.js"),
  "add-to-cart": () => import("./add-to-cart_controller.js"),
  "add-to-cart-analytics": () => import("./add-to-cart-analytics-controller.js"),
  analytics: () => import("./analytics-controller.js"),
  "cart-buttons": () => import("./cart-buttons.js"),
  "cart-count": () => import("./cart-count_controller.js"),
  chocoportrait: () => import("./chocoportrait_controller.js"),
  "chocoportrait-summary": () => import("./chocoportrait-summary_controller.js"),
  "collection-filter": () => import("./collection-filter_controller.js"),
  "copy-to-clipboard": () => import("./copy-to-clipboard_controller.js"),
  curator: () => import("./curator_controller.js"),
  datepicker: () => import("./datepicker_controller.js"),
  "dropdown-filters": () => import("./dropdown-filters_controller.js"),
  "fade-in": () => import("./fade-in_controller.js"),
  "fade-in-childs": () => import("./fade-in-childs_controller.js"),
  "filter-panel": () => import("./filter-panel_controller.js"),
  "flavour-popup": () => import("./flavour-popup_controller.js"),
  form: () => import("./form_controller.js"),
  "form-analytics": () => import("./form-analytics-controller.js"),
  googlemap: () => import("./googlemap_controller.js"),
  "greeting-card-popup": () => import("./greeting-card-popup.js"),
  header: () => import("./header_controller.js"),
  history: () => import("./history_controller.js"),
  "klaviyo-leads": () => import("./klaviyo-leads_controller.js"),
  "location-popup": () => import("./location-popup_controller.js"),
  lockscroll: () => import("./lockscroll_controller.js"),
  lottie: () => import("./lottie_controller.js"),
  "message-banner": () => import("./message-banner_controller.js"),
  "more-results": () => import("./more-results_controller.js"),
  "navigate-back": () => import("./navigate-back_controller.js"),
  newsletter: () => import("./newsletter_controller.js"),
  "order-popup": () => import("./order-popup_controller.js"),
  "out-of-stock": () => import("./out-of-stock_controller.js"),
  parallax: () => import("./parallax_controller.js"),
  "price-calculator": () => import("./price-calculator_controller.js"),
  "product-filter-form": () => import("./product-filter-form_controller.js"),
  quantity: () => import("./quantity_controller.js"),
  "request-submit": () => import("./request-submit_controller.js"),
  "reset-filter": () => import("./reset-filter_controller.js"),
  "select-franchise": () => import("./select-franchise_controller.js"),
  "simple-filters": () => import("./simple-filters_controller.js"),
  swiper: () => import("./swiper_controller.js"),
  tabs: () => import("./tabs_controller.js"),
  turnstile: () => import("./turnstile_controller.js"),
  vidstack: () => import("./vidstack_controller.js"),
});
